import React, { useEffect, useState } from 'react'
import { Table, Card, Tag } from 'antd'
import { listLedger, LedgerEntry } from '../../api/admin'

const Ledger: React.FC = () => {
  const [entries, setEntries] = useState<LedgerEntry[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    loadLedger()
  }, [])

  const loadLedger = async () => {
    try {
      const data = await listLedger({ page: 1, page_size: 100 })
      setEntries(data)
    } catch {
      // 错误已在拦截器中处理
    } finally {
      setLoading(false)
    }
  }

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 80
    },
    {
      title: '用户ID',
      dataIndex: 'user_id',
      key: 'user_id',
      width: 100
    },
    {
      title: '变动',
      dataIndex: 'delta',
      key: 'delta',
      render: (delta: number) => (
        <Tag color={delta > 0 ? 'green' : 'red'}>
          {delta > 0 ? '+' : ''}{delta}
        </Tag>
      )
    },
    {
      title: '原因',
      dataIndex: 'reason',
      key: 'reason'
    },
    {
      title: '时间',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (date: string) => new Date(date).toLocaleString('zh-CN')
    }
  ]

  return (
    <div>
      <h2 style={{ marginBottom: 24 }}>📒 账本管理</h2>

      <Card>
        <Table
          columns={columns}
          dataSource={entries}
          rowKey="id"
          loading={loading}
          pagination={{ pageSize: 20 }}
        />
      </Card>
    </div>
  )
}

export default Ledger
